import React, { FC } from 'react';

const ActiveNoteIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className ?? ''}
    xmlns="http://www.w3.org/2000/svg"
    width="0.3cm"
    height="0.4cm"
    viewBox="0 0 9 11"
  >
    <path
      d="M8.5,1H6.4A1.4,1.4,0,0,0,5,0,1.4,1.4,0,0,0,3.6,1H1.5a1.1,1.1,0,0,0-1,1v8a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V2A1.1,1.1,0,0,0,8.5,1ZM5,1a.5.5,0,0,1,.5.5A.5.5,0,0,1,5,2a.5.5,0,0,1-.5-.5A.5.5,0,0,1,5,1ZM7.7,5,4.5,8.2,2.3,6A.5.5,0,0,1,3,5.3L4.5,6.8,7,4.3a.5.5,0,0,1,.7,0C7.9,4.4,7.9,4.8,7.7,5Z"
      transform="translate(-0.5 0)"
      fill="#282828"
    />
  </svg>
);

export default ActiveNoteIcon;
